
    var ret = {
      defaultLocale: "en-US",
      fallbackLocale: "en-US",
      availableLocales: ["af-ZA","ar-AE","da","de","de-CH","en-US","es","fi-FI","fr-FR","hu","id-ID","it-IT","ja-JP","nb-NO","nl-NL","pl","pt-BR","ro","ru","sk-SK","sv","tr-TR","zh-CN"],
      bundled: {},
      loadables: {},
    };

  // Bundled locales are directly available in the main bundle.
  
    {
      var suffixes = [".ftl"];
      var contents = [];
    
      contents.push(require("/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/en-US/common.ftl").default);
    

      contents.push(require("/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/en-US/framework.ftl").default);
    

      contents.push(require("/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/en-US/ui.ftl").default);
    
      contents = contents.concat(suffixes.map(function(suffix) { return require("/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/en-US/admin" + suffix).default; }));
      ret.bundled["en-US"] = contents.join("\n");
    }
  

  // Loadables are in a separate bundle, that can be easily loaded.
  
    ret.loadables["af-ZA"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-af-ZA", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/af-ZA/framework.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-af-ZA", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/af-ZA/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["ar-AE"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ar-AE", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ar-AE/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ar-AE", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ar-AE/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ar-AE", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ar-AE/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-ar-AE", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ar-AE/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["da"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-da", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/da/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-da", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/da/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-da", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/da/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-da", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/da/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["de"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-de", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/de/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-de", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/de/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-de", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/de/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-de", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/de/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["de-CH"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-de-CH", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/de-CH/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-de-CH", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/de-CH/framework.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-de-CH", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/de-CH/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["es"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-es", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/es/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-es", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/es/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-es", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/es/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-es", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/es/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["fi-FI"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-fi-FI", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/fi-FI/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-fi-FI", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/fi-FI/framework.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-fi-FI", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/fi-FI/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["fr-FR"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-fr-FR", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/fr-FR/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-fr-FR", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/fr-FR/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-fr-FR", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/fr-FR/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-fr-FR", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/fr-FR/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["hu"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-hu", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/hu/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-hu", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/hu/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-hu", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/hu/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-hu", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/hu/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["id-ID"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-id-ID", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/id-ID/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-id-ID", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/id-ID/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-id-ID", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/id-ID/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-id-ID", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/id-ID/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["it-IT"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-it-IT", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/it-IT/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-it-IT", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/it-IT/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-it-IT", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/it-IT/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-it-IT", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/it-IT/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["ja-JP"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ja-JP", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ja-JP/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ja-JP", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ja-JP/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ja-JP", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ja-JP/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-ja-JP", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ja-JP/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["nb-NO"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-nb-NO", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/nb-NO/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-nb-NO", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/nb-NO/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-nb-NO", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/nb-NO/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-nb-NO", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/nb-NO/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["nl-NL"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-nl-NL", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/nl-NL/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-nl-NL", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/nl-NL/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-nl-NL", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/nl-NL/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-nl-NL", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/nl-NL/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["pl"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-pl", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/pl/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-pl", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/pl/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-pl", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/pl/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-pl", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/pl/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["pt-BR"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-pt-BR", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/pt-BR/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-pt-BR", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/pt-BR/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-pt-BR", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/pt-BR/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-pt-BR", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/pt-BR/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["ro"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ro", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ro/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ro", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ro/framework.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-ro", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ro/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["ru"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ru", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ru/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ru", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ru/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-ru", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ru/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-ru", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/ru/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["sk-SK"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-sk-SK", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/sk-SK/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-sk-SK", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/sk-SK/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-sk-SK", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/sk-SK/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-sk-SK", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/sk-SK/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["sv"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-sv", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/sv/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-sv", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/sv/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-sv", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/sv/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-sv", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/sv/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["tr-TR"] = function() {
      var suffixes = [];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-tr-TR", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/tr-TR/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-tr-TR", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/tr-TR/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-tr-TR", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/tr-TR/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-tr-TR", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/tr-TR/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  

    ret.loadables["zh-CN"] = function() {
      var suffixes = [".ftl"];
      var promises = [];
    
      promises.push(
        import(
          /* webpackChunkName: "admin-locale-zh-CN", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/zh-CN/common.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-zh-CN", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/zh-CN/framework.ftl"
        )
      );
    

      promises.push(
        import(
          /* webpackChunkName: "admin-locale-zh-CN", webpackMode: "lazy" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/zh-CN/ui.ftl"
        )
      );
    
      promises = promises.concat(suffixes.map(function(suffix) {
        return import(
          /* webpackChunkName: "admin-locale-zh-CN", webpackMode: "lazy-once" */
          "/build/2da6c3e1-ede5-4c17-94fc-8413a7845965/locales/zh-CN/admin" + suffix
        )
      }));
      return Promise.all(promises).then(function(modules) {
        return modules.map(function(m){return m.default}).join("\n");
      });
    };
  
    module.exports = ret;
  